import get from 'lodash/get';
import isDesktop from '../utils/desktop/isDesktop';
import { DESKTOP_NOW_PLAYING_PAGE_ENABLED } from '../constants/experiments/desktop';
import { DISABLE_LANDING_PRODUCT_FETCH } from '../constants/experiments/config';
import { SUBSCRIPTION_ENABLED } from '../constants/experiments/subscription';

const NAMESPACE = 'config';

export const selectExperiment = (state, key, defaultValue) =>
  get(state, [NAMESPACE, 'autoupdate', key], defaultValue);
export const selectIsDesktopNowPlayingEnabled = (state) =>
  isDesktop() &&
  selectExperiment(state, DESKTOP_NOW_PLAYING_PAGE_ENABLED, false);
export const selectIsSubscriptionEnabled = (state) =>
  !!selectExperiment(state, SUBSCRIPTION_ENABLED, false);
export const selectIsLandingProductFetchDisabled = (state) =>
  selectExperiment(state, DISABLE_LANDING_PRODUCT_FETCH);
